module.exports = __webpack_public_path__ + "img/section1_tab5_img.9ab19aac.svg";